<div class="panel payment-box">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="Title-box-payment d-flex flex-column align-items-center justify-content-start">
      <span>{{ 'OrderDeliveryMethod' | translate }}</span>
    </div>
  </div>
  @for (deliveryMethod of deliveryMethods; track $index) {
    @if (deliveryMethod?.Type === 'OUTSIDE_DELIVER') {
      <div (click)="onChangeDeliveryMethod(deliveryMethod)"
           [ngClass]="{'selected-accept': deliveryMethod?.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId}"
           class="payment-method">
        <div class="d-flex align-items-center gap-2 w-100">
          <mat-icon class="car-icon">local_shipping</mat-icon>
          <div class="flex-grow-1 d-flex align-items-center justify-content-between w-100">
            <div>
              <span>{{ deliveryMethod?.Title | translate }}</span>
              @if (selectedUserAddress && deliveryMethod?.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId) {
                <span>{{ selectedUserAddress?.Title | translate }}</span>
                <p>{{ selectedUserAddress?.Address | translate }} - {{ selectedUserAddress?.Detail | translate }}</p>
                <p>{{ 'DeliveryRecipient' | translate }} : {{ selectedUserAddress?.RecipientFullName | translate }}
                                                         - {{ selectedUserAddress?.Phone | translate }}
                </p>
              }
              <div>
                @if (deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId) {
                  <button
                    (click)="openChangeAddressClicked(); $event.stopPropagation()"
                    style="height: 30px;width: 100px;color: white; background: #0F833F;font-size: 12px; border-radius: 8px;border-color: white;margin-top: 4px">
                    {{ selectedUserAddress ? ('AddressChange' | translate) : ('AddressSelect' | translate) }}
                  </button>
                }
              </div>
            </div>
            <img
              [src]="deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
              class="cursor-pointer">
          </div>
        </div>
        <!--    @if (showSendTime) {-->
        <!--      <div class="col-12 d-flex align-items-center justify-content-between visit mt-2">-->
        <!--        <span>{{ 'VisitInPerson' | translate }}</span>-->
        <!--        <p> 1503/11/02 - 13:30</p>-->
        <!--      </div>-->
        <!--    }-->
      </div>
    } @else if (deliveryMethod.Type === 'INSIDE_DELIVER') {
      <div (click)="onChangeDeliveryMethod(deliveryMethod)"
           [ngClass]="{'selected-accept': deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId}"
           class="payment-method d-flex flex-row align-items-center gap-2">
        <mat-icon class="car-icon">location_on</mat-icon>
        <div class="flex-grow-1 d-flex align-items-center justify-content-between w-100">
          <div>
            <span>{{ deliveryMethod?.Title | translate }} ({{ Config.branch.Title }})</span>
            <p>{{ Config.branch.Details.Address | translate }}</p>
            <p>{{ 'Phone' | translate }} : {{ Config.branch.Details.Phone | translate }}</p>
          </div>
          <img
            [src]="deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
            class="cursor-pointer">
        </div>
      </div>
    } @else if (deliveryMethod.Type === 'INSIDE') {
      <div (click)="onChangeDeliveryMethod(deliveryMethod)"
           [ngClass]="{'selected-accept': deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId}"
           class="payment-method d-flex flex-row align-items-center gap-2">
        <mat-icon class="car-icon">airline_seat_recline_normal</mat-icon>
        <div class="flex-grow-1 d-flex align-items-center justify-content-between w-100">
          <div>
            <span>{{ deliveryMethod?.Title | translate }}</span>
            @if (selectedSpace) {
              <p>{{ 'SelectedSpace' | translate }} : {{ selectedSpace?.Title | translate }}</p>
            }
            <div>
              @if (deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId) {
                <button
                  (click)="openChangeSpaceClicked(); $event.stopPropagation()"
                  style="height: 30px;width: 100px;color: white; background: #0F833F;font-size: 12px; border-radius: 8px;border-color: white;margin-top: 4px">
                  {{ selectedSpace ? ('ChangeSpace' | translate) : ('SelectSpace' | translate) }}
                </button>
              }
            </div>
          </div>
          <img
            [src]="deliveryMethod.DeliveryMethodId === selectedDeliveryMethod?.DeliveryMethodId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
            class="cursor-pointer">
        </div>
      </div>
    }
  }

  <div class="Title-box-payment mb-3">
    <span>{{ 'paymentMethod' | translate }}</span>
  </div>
  @if (selectedDeliveryMethod) {
    @for (paymentMethod of paymentMethods; track $index) {
      <div (click)="onChangePaymentMethod(paymentMethod)"
           [ngClass]="{'selected-accept': selectedPaymentType.PaymentMethodId === paymentMethod.PaymentMethodId}"
           class="payment-method d-flex flex-sm-row flex-column align-items-center">
        @if (paymentMethod?.Type === 'CASH') {
          <img class="ms-2"
               src="/icons/dollar.svg"
               style="height: 40px;width: 40px;padding-left: 6px;padding-right: 6px">
        } @else if (paymentMethod?.Type === 'PSP') {
          @if (paymentMethod.Metadata.PSP === 'SAMAN') {
            <img class="ms-2"
                 src="/icons/logo-saman-bank.svg"
                 style="height: 40px;width: 40px;">
          } @else if (paymentMethod.Metadata.PSP === 'ZARINPAL') {
            <img class="ms-2"
                 src="/icons/zarinpal.svg"
                 style="height: 40px;width: 40px;">
          } @else if (paymentMethod.Metadata.PSP === 'MELAT') {
            <img class="ms-2"
                 src="/icons/behpardakht.svg"
                 style="height: 40px;width: 40px;">
          } @else {
            <img class="ms-2"
                 src="/icons/image-placeholder.svg"
                 style="height: 40px;width: 40px;">
          }
        } @else if (paymentMethod?.Type === 'WALLET') {
          <img class="ms-2"
               src="/icons/wallet.svg"
               style="height: 40px;width: 40px;padding-left: 6px;padding-right: 6px">
        } @else if (paymentMethod?.Type === 'CARD_TO_CARD') {
          <img class="ms-2"
               src="/icons/card.svg"
               style="height: 40px;width: 40px;padding-left: 6px;padding-right: 6px">
        }
        <div class="flex-grow-1 d-flex align-items-center justify-content-between w-100">
          <div>
            <span>{{ paymentMethod.Title | translate }}</span>
          </div>
          <img
            [src]="selectedPaymentType.PaymentMethodId === paymentMethod.PaymentMethodId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
            class="cursor-pointer">
        </div>
      </div>
    }
  } @else {
    <div class="col-12 d-flex flex-row flex-column align-items-center"
         style="margin-top: 40px;margin-bottom: 40px">
      <img [src]="'/icons/delivery-method.svg'"
           style="width: 10%;height: 10%">
      <span style="margin-top: 20px">{{ 'FirstSelectDeliveryMethod' | translate }}</span>
    </div>
  }
  <div>
    <div class="financial-content border-0">
      <div class="d-flex align-items-center justify-content-between">
        <span>{{ 'ShippingCost' | translate }}</span>
        @if (!selectedDeliveryMethod) {
          <p class="color-txt">{{ 'DeliveryPriceAfterSelect' | translate }}</p>
        } @else {
          <p class="color-txt">{{ StringUtil.numberAsCurrency(preFactor?.DeliveryPrice ?? 0) + 'ریال' }}</p>
        }
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center mb-0 gap-2">
          <span>{{ 'ValueAddedTax' | translate }}</span>
          <p class="color-txt">{{ '٪' + StringUtil.numberAsCurrency(preFactor?.TaxPercent ?? 0) }}</p>
        </div>
        <p class="color-txt">{{ StringUtil.numberAsCurrency(preFactor?.TaxPrice ?? 0) + ' ریال' }}</p>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <span>{{ 'Sum' | translate }}</span>
        <p class="color-txt">{{ StringUtil.numberAsCurrency(preFactor?.PayablePrice ?? 0) + ' ریال' }}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <app-frontend-button
      (click)="onRegisterOrderClicked()"
      [disabled]="(!selectedPaymentType || !selectedDeliveryMethod)"
      [ngClass]="{'card-disable':(!selectedPaymentType || !selectedDeliveryMethod)}"
      [title]="(!selectedPaymentType ? 'SelectOneOfPaymentMethod' : 'Payment')"></app-frontend-button>
  </div>
</div>
